import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { HighlightedPriceDisplay } from 'pricing-pages-ui/components/common/pricing/HighlightedPriceDisplay';
import SuiteProductLevelIdentifiersMap from 'pricing-pages-ui/constants/merchCards/SuiteProductLevelIdentifiersMap';
import { hasPricingAndPurchasingSucceededSelector } from 'pricing-pages-ui/selectors/LoadingStateSelectors';
import { calculatedPriceSelector } from 'pricing-pages-ui/selectors/PricingSelectors';
import { suiteProductConfigurationsSelector } from 'pricing-pages-ui/selectors/ProductConfigsSelectors';
import { quantityPackProductConfigurationsFromProductInventorySelector } from 'pricing-pages-ui/selectors/ProductInventorySelectors';
import { useValidatedCrmSuiteQueryParamTerm } from 'pricing-pages-ui/utils/urls/queryParamUtils';
import { useSelector } from 'react-redux';
export const CrmSuitePrice = (_ref) => {
  let {
    productLevel,
    termOverride
  } = _ref,
      restProps = _objectWithoutPropertiesLoose(_ref, ["productLevel", "termOverride"]);

  const hasPricingAndPurchasingSucceeded = useSelector(hasPricingAndPurchasingSucceededSelector);
  const {
    queryParamTerm
  } = useValidatedCrmSuiteQueryParamTerm({
    productLevel
  });
  const suiteProductConfigurations = useSelector(state => suiteProductConfigurationsSelector(state, {
    productLevel
  }));
  const ownedQuantityPackProductConfigurations = useSelector(state => {
    return quantityPackProductConfigurationsFromProductInventorySelector(state, {
      baseProductConfigurations: suiteProductConfigurations
    });
  });
  const checkoutProductConfigurations = [...suiteProductConfigurations, ...ownedQuantityPackProductConfigurations];
  const pricingInfo = useSelector(reduxState => {
    if (!hasPricingAndPurchasingSucceeded) return null;
    return calculatedPriceSelector(reduxState, {
      productConfigurations: checkoutProductConfigurations,
      queryParamTerm: termOverride || queryParamTerm
    });
  });
  return /*#__PURE__*/_jsx(HighlightedPriceDisplay, Object.assign({
    pricingInfo: pricingInfo,
    nonMerchandiseIdProduct: SuiteProductLevelIdentifiersMap[productLevel]
  }, restProps));
};